import CheckIcon from '../Icons/CheckIcon';
import { SwitchBackground, SwitchForeground, SwitchForegroundGhost } from './styles';

interface Props {
	name?: string;
	onChange: () => void;
	value: boolean;
}
export default function Switch({ name, onChange, value }: Props) {
	return (
		<SwitchBackground
			onClick={onChange}
			value={value}
			title={`Switch ${name ? name : ''} ${value ? 'off' : 'on'} `}
		>
			<SwitchForeground>{value && <CheckIcon />}</SwitchForeground>
			<SwitchForegroundGhost />
		</SwitchBackground>
	);
}
